export default [
  /** 维保 开始 */
  {
    path: '/maintenance/maintenanceList',
    name: 'MaintenanceList',
    component: () => import(/* webpackChunkName: "MaintenanceList" */ '../../views/maintenance/maintenanceList.vue'),
    meta: {
      title: '维保单',
    },
  },
  {
    path: '/maintenance/subscribe',
    name: 'Subscribe',
    component: () => import(/* webpackChunkName: "Subscribe" */ '../../views/maintenance/subscribe.vue'),
    meta: {
      title: '预约维保',
    },
  },
  {
    path: '/maintenance/maintenanceDetails/:type',
    // path: '/fans/fansDetail/:type',

    name: 'MaintenanceDetails',
    component: () =>
      import(/* webpackChunkName: "MaintenanceDetails" */ '../../views/maintenance/maintenanceDetails.vue'),
    meta: {
      title: '维保详情',
    },
  },
  {
    path: '/maintenance/workOrderDet/:type',
    name: 'WorkOrderDet',
    component: () => import(/* webpackChunkName: "MaintenanceDetails" */ '../../views/maintenance/workOrderDet.vue'),
    meta: {
      title: '工单详情',
    },
  },
  {
    path: '/maintenance/evaluate/:type',
    name: 'Evaluate',
    component: () => import(/* webpackChunkName: "MaintenanceDetails" */ '../../views/maintenance/evaluate.vue'),
    meta: {
      title: '评价',
    },
  },
  /** 维保 结束 */
]
